import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

type Payload = {
  processId: string;
  status: 'approve' | 'reject';
  comment: string;
};

const useSendApproverDecisionMutation = () => {
  const { mutateAsync, isPending } = ApprovalFlows.sendApproverDecision();

  const sendDecision = ({ processId, status, comment }: Payload) =>
    mutateAsync({
      urlParams: { requestId: processId, status },
      data: { comment },
    });

  return {
    sendDecision,
    isPending,
  };
};

export default useSendApproverDecisionMutation;
